import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Badge = _resolveComponent("Badge")
  const _component_FunctionsCatalogGeneralTab = _resolveComponent("FunctionsCatalogGeneralTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_FunctionsCatalogInputTab = _resolveComponent("FunctionsCatalogInputTab")
  const _component_FunctionsCatalogScriptTab = _resolveComponent("FunctionsCatalogScriptTab")
  const _component_FunctionsCatalogOutputTab = _resolveComponent("FunctionsCatalogOutputTab")
  const _component_TabView = _resolveComponent("TabView")
  const _component_FunctionsCatalogWarningDialog = _resolveComponent("FunctionsCatalogWarningDialog")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "function-catalog-detail-dialog",
    class: "full-screen-dialog p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.functionsCatalogDetailDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: false,
    closable: false,
    position: "right",
    baseZIndex: 1,
    autoZIndex: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.selectedFunction.name), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "kn-button p-button-text p-m-2",
            label: _ctx.$t('common.close'),
            onClick: _ctx.closeFunctionDetail
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            class: "kn-button p-button-text",
            label: _ctx.$t('common.save'),
            disabled: _ctx.readonly,
            onClick: _ctx.onSave
          }, null, 8, ["label", "disabled", "onClick"])
        ]),
        _: 1
      }),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_TabView, null, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('common.general')), 1),
              (_ctx.invalidGeneral)
                ? (_openBlock(), _createBlock(_component_Badge, {
                    key: 0,
                    class: "p-ml-2",
                    severity: "danger"
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_FunctionsCatalogGeneralTab, {
                propFunction: _ctx.selectedFunction,
                readonly: _ctx.readonly,
                functionTypes: _ctx.filteredFunctionTypes
              }, null, 8, ["propFunction", "readonly", "functionTypes"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('common.input')), 1),
              (_ctx.invalidInput)
                ? (_openBlock(), _createBlock(_component_Badge, {
                    key: 0,
                    class: "p-ml-2",
                    severity: "danger"
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_FunctionsCatalogInputTab, {
                propFunction: _ctx.selectedFunction,
                readonly: _ctx.readonly
              }, null, 8, ["propFunction", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('common.script')), 1),
              (_ctx.invalidCode)
                ? (_openBlock(), _createBlock(_component_Badge, {
                    key: 0,
                    class: "p-ml-2",
                    severity: "danger"
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_FunctionsCatalogScriptTab, {
                propFunction: _ctx.selectedFunction,
                readonly: _ctx.readonly
              }, null, 8, ["propFunction", "readonly"])
            ]),
            _: 1
          }),
          _createVNode(_component_TabPanel, null, {
            header: _withCtx(() => [
              _createVNode("span", null, _toDisplayString(_ctx.$t('common.output')), 1),
              (_ctx.invalidOutput)
                ? (_openBlock(), _createBlock(_component_Badge, {
                    key: 0,
                    class: "p-ml-2",
                    severity: "danger"
                  }))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_FunctionsCatalogOutputTab, {
                propFunction: _ctx.selectedFunction,
                readonly: _ctx.readonly
              }, null, 8, ["propFunction", "readonly"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FunctionsCatalogWarningDialog, {
        visible: _ctx.warningVisible,
        title: _ctx.warningTitle,
        missingFields: _ctx.missingFields,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.warningVisible = false))
      }, null, 8, ["visible", "title", "missingFields"])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
}